jQuery(document).ready(function () {
  if ($(".lastpublications").length > 0) {
    const alldate = [];
    var allPublications = $(".lastpublications_card");
    allPublications.each(function () {
      var date = $(this).data("date");
      alldate.push(date);
    });
    alldate.sort((a, b) => Date.parse(b) - Date.parse(a));
    alldate.splice(4, 8);
    // console.log(alldate);

    allPublications.each(function () {
        var itemdate = $(this).data("date");
        if ( alldate.includes(itemdate)){
            
        }else{
            $(this).hide();
        }
    });
  }
});
